<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'statisticsBox'
}
</script>

<style scoped>

</style>
